const normalizeDocId = (value) => String(value || '').trim();

const hasNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;

const hasNonEmptyStringList = (value) => Array.isArray(value) && value.some(hasNonEmptyString);

const hasModernResultSignals = (documentData) => {
  if (!documentData || typeof documentData !== 'object') {
    return false;
  }

  return (
    hasNonEmptyString(documentData.generation_status) ||
    hasNonEmptyString(documentData.preview_video_url) ||
    hasNonEmptyString(documentData.unlock_source) ||
    Boolean(documentData.is_daily_generation) ||
    hasNonEmptyStringList(documentData.output_videos)
  );
};

const isLegacyResultDocument = (documentData) => {
  if (!documentData || typeof documentData !== 'object') {
    return false;
  }

  if (hasModernResultSignals(documentData)) {
    return false;
  }

  const hasLegacyImages = hasNonEmptyStringList(documentData.output_images);
  const hasLegacyCompanionField =
    hasNonEmptyStringList(documentData.output_special_images) ||
    Array.isArray(documentData.image_quality) ||
    Array.isArray(documentData.special_image_quality);

  return hasLegacyImages && hasLegacyCompanionField;
};

const isModernResultDocument = (documentData) => hasModernResultSignals(documentData);

const getLegacyResultPath = (docId) => `/result/${normalizeDocId(docId)}`;

const getModernResultPath = (docId) => `/videos/${normalizeDocId(docId)}`;

const getResultPathForDocument = (docId, documentData) => (
  isLegacyResultDocument(documentData)
    ? getLegacyResultPath(docId)
    : getModernResultPath(docId)
);

const getAbsolutePathUrl = (path, originOverride) => {
  const origin = originOverride || (typeof window !== 'undefined' ? window.location.origin : '');
  return origin ? `${origin}${path}` : path;
};

const getLegacyResultUrl = (docId, originOverride) => (
  getAbsolutePathUrl(getLegacyResultPath(docId), originOverride)
);

const getModernResultUrl = (docId, originOverride) => (
  getAbsolutePathUrl(getModernResultPath(docId), originOverride)
);

export {
  getLegacyResultPath,
  getModernResultPath,
  getResultPathForDocument,
  getLegacyResultUrl,
  getModernResultUrl,
  isLegacyResultDocument,
  isModernResultDocument,
};
